<template>
    <div class="card p-fluid">
        <h5><b>계정 정보</b></h5>
        <div class="p-field p-grid">
            <label for="name3" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">이름:</label>
            <!-- <p>Account Management</p> -->
            <div class="p-col-12 p-md-10">{{name}}</div>
        </div>
        <div class="p-field p-grid">
            <label for="email3" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">이메일:</label>
            <div class="p-col-12 p-md-10">{{email}}</div>
        </div>
        <div class="p-field p-grid">
            <label for="email3" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">연락처:</label>
            <div class="p-col-12 p-md-10">{{phone_number}}</div>
        </div>
        <!-- <div class="p-field p-grid">
            <label for="name3" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">비밀번호:</label>
            <div class="p-col-12 p-md-10"><Button :label="$t('패스워드 초기화')" iconPos="left"
                    class="p-button-outlined p-mr-2 p-mb-2" @click="changepass"></Button></div>
        </div> -->
        <div class="p-d-flex p-jc-between">
            <Button label="Primary" class="p-button-outlined p-mr-2 p-mb-2" @click="editinfo" style="background: black; color: white;">{{ $t('수정') }}</Button>
            <Button label="Primary" class="p-button-outlined p-mr-2 p-mb-2" @click="$router.go(-1)" style="background: white; color: black;">{{ $t('뒤로가기')
            }}</Button>
        </div>

    </div>

</template>
<script>
export default {
    data() {
        return {
            name: localStorage.getItem('AdminName'),
            email: localStorage.getItem('Email'),
            phone_number: localStorage.getItem('Phone'),
        }
    },
    methods: {
        changepass() {
            this.$router.push({ name: 'ChangePass' });
        },
        editinfo() {
            this.$router.push({ name: 'EditInfo' });
        }
    },
};
</script>

<style scoped>
.p-fluid .p-button {
    width: auto;
}
</style>
